import {Button, Card, Checkbox, Form, Input, Select, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";
import SubList from "../../components/SubList";
import DocumentList from "../../components/DocumentList";

class Create extends React.Component {

  state = {
    gstStatus: '',
    businessEntity: '',
    industryType: '',
    documentData: [],
  };

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  getDocumentData = (data) => {
    this.setState({ documentData: data });
  };


  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.data && (nextProps.data.gstRegistrationStatus !== this.props.data.gstRegistrationStatus)) {
      this.setState({ gstStatus: nextProps.data.gstRegistrationStatus });
    }
    if (nextProps && nextProps.data && (nextProps.data.typeOfBusinessEntity !== this.props.data.typeOfBusinessEntity)) {
      this.setState({ businessEntity: nextProps.data.typeOfBusinessEntity });
    }
    if (nextProps && nextProps.data && (nextProps.data.typeOfIndustry !== this.props.data.typeOfIndustry)) {
      this.setState({ industryType: nextProps.data.typeOfIndustry });
    }
  }


  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      const { documentData } = this.state;
      const data = Object.assign({}, values);
      if (documentData.length === 0) {
        data.documents = this.props && this.props.data && this.props.data.documents;
      } else {
        data.documents = documentData ;
      }

      if (match.params && match.params.id) {
        this.props.onSubmit(data, match.params.id);
      } else {
        this.props.onSubmit(data);
      }
    });
  };

  selectGstStatus = (e) => {
    this.setState({gstStatus: e});
  };

  selectTypeOfBusinessEntity = (e) => {
    this.setState({businessEntity: e});
  };

  selectTypeOfIndustry = (e) => {
    this.setState({industryType: e});
  };



  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form, subDocumentFilters} = this.props;

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              const dataKey = item.split('.')[1] ? item.split('.')[1] : item;
              const dataKeyObj = item.split('.')[1] ? item.split('.')[0] : null;


              const value = data && data[dataKeyObj ? dataKeyObj : item] ? (dataKeyObj ? data[dataKeyObj][dataKey] : data[dataKey]) : null;

              if (item === 'name') {
                return <Form.Item key={item} label={'Company Name'}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${item} is required!` }],
                    initialValue: value
                  })(<Input/>)
                  }
                </Form.Item>;
              }

              if (filters[item].field === 'gstRegistrationStatus') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${item} is required!` }],
                    initialValue: item !== 'password' ? value : '',
                  })(<Select
                    onSelect={this.selectGstStatus.bind(this)}
                    placeholder={`Please select ${sanitizeFieldName(filters[item].field)}`}
                  >
                    {filters[item].options.enum.map(item => <Select.Option key={item}
                                                                           value={item}>{item}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>;
              }

              if (item === 'gstDetails' && this.state.gstStatus === 'REGISTERED') {
                return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>
              }

              if (item === 'typeOfBusinessEntity') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${item} is required!` }],
                    initialValue: value
                  })(<Select
                    onSelect={this.selectTypeOfBusinessEntity.bind(this)}
                    placeholder={`Please select ${sanitizeFieldName(filters[item].field)}`}
                  >
                    {filters[item].options.enum.map(item => <Select.Option key={item}
                                                                           value={item}>{item.split('_').join(' ')}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>;
              }

              if (item === 'otherTypeOfBusinessEntity' && this.state.businessEntity === 'OTHER') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${item} is required!` }],
                    initialValue: value
                  })(<Input/>)
                  }
                </Form.Item>;
              }


              if (item === 'typeOfIndustry') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${item} is required!` }],
                    initialValue: value
                  })(<Select
                    onSelect={this.selectTypeOfIndustry.bind(this)}
                    placeholder={`Please select ${sanitizeFieldName(filters[item].field)}`}
                  >
                    {filters[item].options.enum.map(item => <Select.Option key={item}
                                                                           value={item}>{item.split('_').join('/')}</Select.Option>)}
                  </Select>)
                  }
                </Form.Item>;
              }

              if (item === 'otherTypeOfIndustry' && this.state.industryType === 'OTHER') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${item} is required!` }],
                    initialValue: value
                  })(<Input/>)
                  }
                </Form.Item>;
              }



              if (filters[item].type === 'Boolean') {
                return <Form.Item key={item} label={sanitizeFieldName(item)}>
                  {getFieldDecorator(item, {
                    rules: [{ required: filters[item].required, message: `${item} is required!` }],
                    valuePropName: 'checked',
                    initialValue: value,
                  })(<Checkbox></Checkbox>)}
                </Form.Item>
              }
              if (filters[item].type === 'Array' && filters[item].schema) {
                if(item !== 'gstDetails') {
                  return <SubList key={item} item={filters[item]} form={form} data={data[item]} title={title} resource={resource}/>
                }
              } else {
                if (filters[item].type === 'Array' && filters[item].options.ref === 'Document') {
                  return <DocumentList match={this.props.match} history={this.props.history} key={item} item={filters[item]} form={form} data={data[item]} subDocumentFilters={subDocumentFilters} getDocumentData={this.getDocumentData}/>
                }
                if (item !== 'gstRegistrationStatus' && item !== 'typeOfBusinessEntity' && item !== 'typeOfIndustry' && item !== 'otherTypeOfBusinessEntity' && item !== 'otherTypeOfIndustry' && item !== 'name') {
                  return getFormFieldByType(filters, item, getFieldDecorator, data, {resource})
                }
              }
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
